/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *
 */

import styled from 'styled-components';
import Badge from 'react-bootstrap/Badge';

export const AddSearch = styled.div`
  padding: 5px;
  background-color: #ccc;
  width: 35px;
  height: 35px;
  border-radius: 10%;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const HeaderText = styled.span`
  font-size: 14px;
  font-weight: bold;
`;

export const BadgeContainer = styled(Badge)`
  background-color: #d5d5d5 !important;
  color: #000;
`;

export const SearchType = styled.span`
  font-size: 14px;
  color: #505050;
  font-weight: normal;
`;

export const SearchValue = styled.span`
  font-weight: 500;
`;
